import { AxiosResponse } from 'axios';
import requester from '@/lib/axios';
import { TrueOrFalseActivityProgress } from '@/models/_deprecated/ActivityProgress';
import { QuestionProgressAttempt } from '@/models/QuestionProgressAttempt';
import { TrueOrFalseQuestionCorrectAnswer } from '@/models/QuestionCorrectAnswer';

export interface GetTrueOrFalseProgressParams {
  trueOrFalseId: number;
  trueOrFalseProgressId: number;
}

export const getTrueOrFalseProgress = async ({
  trueOrFalseId,
  trueOrFalseProgressId,
}: GetTrueOrFalseProgressParams) => {
  const { data: trueOrFalseProgress } =
    await requester().get<TrueOrFalseActivityProgress>(
      `true-or-false-activity/${trueOrFalseId}/true-or-false-activity-progress/${trueOrFalseProgressId}/`,
    );
  return trueOrFalseProgress;
};

type UpdateTureOrFalseProgress = Pick<
  TrueOrFalseActivityProgress,
  'isDone' | 'answer'
>;

export const updateTrueOrFalseProgress = async (
  { trueOrFalseId, trueOrFalseProgressId }: GetTrueOrFalseProgressParams,
  body: UpdateTureOrFalseProgress,
) => {
  type Response = AxiosResponse<TrueOrFalseActivityProgress>;
  const { data: trueOrFalseProgress } = await requester().patch<
    UpdateTureOrFalseProgress,
    Response
  >(
    `true-or-false-activity/${trueOrFalseId}/true-or-false-activity-progress/${trueOrFalseProgressId}/`,
    body,
  );
  return trueOrFalseProgress;
};

type TrueOrFalseAttemptBody = Pick<TrueOrFalseActivityProgress, 'answer'>;

export const updateTrueOrFalseAttempt = async (
  { trueOrFalseId, trueOrFalseProgressId }: GetTrueOrFalseProgressParams,
  body: TrueOrFalseAttemptBody,
) => {
  const { data: attempt } = await requester().patch<QuestionProgressAttempt>(
    `true-or-false-activity/${trueOrFalseId}/true-or-false-activity-progress/${trueOrFalseProgressId}/attempt/`,
    body,
  );
  return attempt;
};

export const getTrueOrFalseCorrectAnswer = async ({
  trueOrFalseId,
  trueOrFalseProgressId,
}: GetTrueOrFalseProgressParams) => {
  const { data } = await requester().get<TrueOrFalseQuestionCorrectAnswer>(
    `true-or-false-activity/${trueOrFalseId}/true-or-false-activity-progress/${trueOrFalseProgressId}/correct-answer/`,
  );
  return data;
};
